<script>
export let params;
</script>

<main class="notfound">
<h1>Page <em>{params.wild}</em> not found</h1>
<p>
The <a href="#/">table of contents</a> might have what you're looking for.
</p>
</main>

<style>
.notfound {
    max-width: 40em;
    margin: 0 auto;
}
h1 {
    margin-top: 1.5em;
    margin-bottom: 1em;
}
a {
    color: rgb(0, 89, 178);
    text-decoration: none;
    border: none;
}

</style>
